import type { AudioUnitType } from "./audioUnitManifest";

export type SubscriptionTier = "free" | "premium";

export interface RemoteAudioMonetizationPolicy {
  starterUnitsUnlockedByDefault: boolean;
  rewardedUnlockUnitTypes: AudioUnitType[];
  relockFreeUnitsWhenAssetsMissing: boolean;
  interstitialCooldownMs: number;
}

export const DEFAULT_REMOTE_AUDIO_MONETIZATION_POLICY: RemoteAudioMonetizationPolicy = {
  starterUnitsUnlockedByDefault: true,
  rewardedUnlockUnitTypes: ["intentHeading", "scenarioVocabulary", "scenarioMissions"],
  relockFreeUnitsWhenAssetsMissing: true,
  interstitialCooldownMs: 120000,
};

export function shouldRequireRewardedUnlock(
  subscriptionTier: SubscriptionTier,
  unitType: AudioUnitType,
): boolean {
  if (subscriptionTier === "premium") {
    return false;
  }
  return DEFAULT_REMOTE_AUDIO_MONETIZATION_POLICY.rewardedUnlockUnitTypes.includes(unitType);
}
